// src/mixin/myTeam/resumeManagement/index.js
import { ValidationObserver, ValidationProvider } from "vee-validate";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  props: {
    user_id: {
      type: [String, Number],
      required: true,
    },
  },

  components: {
    vueDropzone: vue2Dropzone,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      edit: false,
      resumeId: null,
      items: [],
      loading: false,
      fields: [
        { key: "description", label: "Description" },
        { key: "google_drive_link", label: "URL" },
        { key: "url", label: "Resume File" },
        { key: "uploaded_by", label: "Uploaded By" },
        { key: "created_at", label: "Uploaded At" },
      ],
      eitherOrError: "",
      hasFile: false,
      acceptedFileCount: 0,
      stickyHeader: true,
      noCollapse: false,
      showEitherOrError: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/project/task/image-store`,
        maxFiles: 1,
        uploadMultiple: false,
        parallelUploads: 100,
        addRemoveLinks: true,
        addViewLinks: true,
        acceptedFiles: ".pdf",
        dictDefaultMessage:
          "<b class='drop-title'>Drag & drop files</b> <br> <p class='drop-req'>Supported formats: PDF <br />",
        init: function () {
          this.on("addedfile", function () {});
        },
      },
      FileErrorMsg: null,
      preloadedFile: null,
      errorFileList: [],
      file: [],
      description: "",
      resumeList: [],
      google_drive_link: "",
      url: null,
      loader: false,
      userId: this.user_id,
      uploadedFileUrl: null,
      remove_attachments: [],
      attachments: [],
      task_attachments: [],
      wasFileInitiallyPresent: false,
    };
  },

  mounted() {
    this.userId = this.user_id;
    if (
      this.$store.state.app.usersList &&
      this.$store.state.app.usersList.length === 0
    ) {
      this.userList();
    }
    this.userResumes();
  },

  computed: {
    tableFields() {
      let baseFields = [...this.fields];
      if (this.userInfo && this.userInfo.role === "SA") {
        baseFields.push({
          key: "action",
          label: "Action",
          tdClass: "actionBtn",
        });
      }
      return baseFields;
    },

    isSubmitDisabled() {
      const hasDescription = this.description && this.description.trim() !== "";
      const hasGoogleLink =
        this.google_drive_link && this.google_drive_link.trim() !== "";
      const isGoogleLinkValid = hasGoogleLink
        ? this.isValidGoogleDriveLink(this.google_drive_link)
        : false;
      const hasFile =
        (this.file && this.file.length > 0) ||
        (this.task_attachments && this.task_attachments.length > 0);
      const canSubmit =
        hasDescription && ((hasGoogleLink && isGoogleLinkValid) || hasFile);

      this.eitherOrError = !canSubmit
        ? "Either Google Drive Link or Resume File is required."
        : null;
      return !canSubmit;
    },
  },

  watch: {
    user_id() {
      this.userId = this.user_id;
      this.userResumes();
    },
  },

  methods: {
    isValidGoogleDriveLink(link) {
      if (!link) return true;
      const urlRegex = /^(https?:\/\/)([\w\-]+\.)+[\w\-]{2,}(\/\S*)?$/;
      return urlRegex.test(link.trim());
    },

    async downloadFile(data) {
      try {
        let URL = `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/admin/master/resume/download?url=${data.item.url}`;

        const response = await this.$axios({
          url: URL,
          method: "GET",
          params: { url: data.item.url },
          responseType: "blob",
        });

        const disposition = response.headers["content-disposition"];
        let fileName = data.item.file_name;
        if (disposition && disposition.indexOf("filename=") !== -1) {
          fileName = disposition.split("filename=")[1].replace(/"/g, "");
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        this.createDownloadLink(downloadUrl, fileName);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },

    createDownloadLink(url, name) {
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    async userResumes() {
      this.items = [];
      this.loading = true;
      const input = { user_id: this.userId };
      const response = await this.getHTTPPostResponse(
        "admin/master/resume",
        input,
        false
      );
      if (response && response.data) {
        this.items = response.data.resumes;
      }
      this.loading = false;
    },

    openAddModal() {
      this.edit = false;
      this.currentId = null;
      this.loader = false;
      this.description = "";
      this.google_drive_link = "";
      this.file = null;
      this.$bvModal.show("AddResume");
    },

    clearModelData() {
      if (this.$refs.clientObserver) {
        this.$refs.clientObserver.reset();
      }

      this.edit = false;
      this.resumeId = null;
      this.description = "";
      this.google_drive_link = "";
      this.file = [];
      this.task_attachments = [];
      this.remove_attachments = [];
      this.errorFileList = [];
      this.FileErrorMsg = null;
      this.eitherOrError = "";
      this.invalidLinkError = "";
      this.showEitherOrError = false;
      this.loader = false;

      if (this.$refs.myVueDropzone) {
        this.$refs.myVueDropzone.removeAllFiles(true);
      }
    },

    validationForm() {
      this.showEitherOrError = true;
      this.$refs.clientObserver.validate().then((success) => {
        if (!success || this.isSubmitDisabled) return;

        if (
          (this.$refs.myVueDropzone &&
            this.$refs.myVueDropzone.getAcceptedFiles().length > 1) ||
          this.errorFileList.length > 0
        ) {
          this.FileErrorMsg = "Please upload only one valid file.";
          return;
        }

        this.FileErrorMsg = "";

        if (this.edit) {
          this.updateResume();
        } else {
          this.createResume();
        }
      });
    },

    handleFileAdding(file) {
      if (file.status === "success") {
        this.FileErrorMsg = null;
        if (!Array.isArray(this.file)) {
          this.file = [];
        }
        this.file.push(file);
      }
    },

    handleFileError(file, message) {
      this.FileErrorMsg = message;
      this.errorFileList.push(file);
    },

    async createResume() {
      this.loader = true;

      const formData = {
        description: this.description,
        google_drive_link: this.google_drive_link,
        user_id: this.user_id,
      };

      const uploadedFiles = this.$refs.myVueDropzone.getAcceptedFiles();
      if (uploadedFiles.length > 0) {
        formData.files = await Promise.all(
          uploadedFiles.map(async (file) => ({
            name: file.name,
            file: await this.convertFileToBase64(file),
          }))
        );
      }

      const response = await this.getHTTPPostResponse(
        "admin/master/resume/create",
        formData,
        true
      );

      if (response && response.status) {
        this.$bvModal.hide("AddResume");
        this.description = null;
        this.google_drive_link = null;
        this.url = null;
        this.$refs.myVueDropzone.removeAllFiles(true);
        this.clearModelData();
        this.userResumes();
      }

      this.loader = false;
    },

    removeFile(file) {
      if (file.id) {
        this.remove_attachments.push(file.id);
        const task_attachmentsIndex = this.task_attachments.findIndex(
          (x) => x.id === file.id
        );
        this.task_attachments.splice(task_attachmentsIndex, 1);
      } else {
        if (file.status == "success") {
          const fileIndex = this.file.findIndex(
            (x) => x.upload.uuid === file.upload.uuid
          );
          this.file.splice(fileIndex, 1);
        }

        const ErrorFileIndex = this.errorFileList.findIndex(
          (x) => x.upload.uuid === file.upload.uuid
        );
        this.errorFileList.splice(ErrorFileIndex, 1);

        this.FileErrorMsg =
          this.errorFileList && this.errorFileList.length
            ? this.FileErrorMsg
            : null;
      }
    },

    async deleteConfirmation(id) {
      const title = "Are you sure you want to delete this Resume?";
      const confirmation = await this.conformationAlert(
        true,
        title,
        "Yes, delete it!",
        "<p>You won’t be able to revert this!</p>"
      );
      if (confirmation.isConfirmed) {
        this.deleteResume(id);
      }
    },

    async deleteResume(id) {
      const response = await this.getHTTPDeleteResponse(
        `admin/master/resume/delete/${id}`,
        {},
        true
      );
      if (response && response.status == 200) {
        this.userResumes();
      }
    },

    editMethod(item) {
      this.edit = true;
      this.resumeId = item.id;
      this.description = item.description;
      this.google_drive_link = item.google_drive_link;
      this.file = [];

      if (item.url) {
        this.wasFileInitiallyPresent = true;

        const file = {
          size: 150,
          name: `${item.file_name}`,
          type: `${item.file_type}`,
          id: item.id,
          url: item.url,
          status: "manuallyAdded",
        };

        this.openFileInNewTab(item.url, false).then((response) => {
          if (!this.actionTypeCheck) {
            this.$refs.myVueDropzone.manuallyAddFile(file, response);
          }
        });

        this.task_attachments.push(file);
      } else {
        this.wasFileInitiallyPresent = false;
      }
      this.$bvModal.show("AddResume");
    },

    async updateResume() {
      this.loader = true;
      const isFileRemoved =
        this.wasFileInitiallyPresent && this.task_attachments.length == 0;
      let files = this.file
        ? await Promise.all(
            this.file.map(async (file) => ({
              name: file.name,
              file: await this.convertFileToBase64(file),
            }))
          )
        : [];

      const formData = {
        description: this.description,
        google_drive_link: this.google_drive_link,
        files,
        remove_file: isFileRemoved,
        user_id: this.user_id,
      };

      const response = await this.getHTTPPostResponse(
        `admin/master/resume/update/${this.resumeId}`,
        formData,
        true
      );

      if (response && response.status === 200) {
        this.$bvModal.hide("AddResume");
        this.userResumes();
        this.clearModelData();
      }
      this.loader = false;
    },
  },
};
